import type { BFLTableRow, BFLTableColumn } from "@repo/shared-ui/BFLTable";
import { ITableOption } from "./types";

const DEFAULT_EMPTY_VALUE = "-";

// Generate unique key from row object - scoped to tab to avoid duplicates across tabs
const generateRowKey = (row: Record<string, string>, index: number, tabName: string): string => {
    return `${tabName}-row-${index}`;
};


export const buildCorporateActionTable = (
    options: Record<string, ITableOption>,
    data: Record<string, Record<string, string>[]> = {},
): Record<string, { columns: BFLTableColumn[]; rows: BFLTableRow[] }> => {
    const result: Record<string, { columns: BFLTableColumn[]; rows: BFLTableRow[] }> = {};
    const dateFields = ["exDate", "recDate", "exBonus"];
    const dateFormatOption: Intl.DateTimeFormatOptions = { day: "2-digit", month: "short", year: "numeric" };

    Object.entries(data).forEach(([tabName, tabData]) => {
        const tabOptions = options[tabName];
        
        if (!tabOptions?.columnOrder?.length) {
            result[tabName] = { columns: [], rows: [] };
            return;
        }
        const {
            columnOrder,
            columnAlignments,
            rowHeaderKey,
            emptyValue = DEFAULT_EMPTY_VALUE,
        } = tabOptions;

        const headerKey = rowHeaderKey ?? columnOrder?.[0]?.key;

        const columns: BFLTableColumn[] = columnOrder.map((obj) => ({
            key: obj.key,
            title: obj.label,
            align: columnAlignments?.[obj.key] ?? "left",
            isRowHeader: obj?.key === headerKey,
        }));

        const rows: BFLTableRow[] = tabData.map((row, index) => {
            const key = generateRowKey(row, index, tabName);
            const cells = columnOrder.reduce<Record<string, string>>((acc, obj) => {
                let cellValue = row?.[obj?.key] ?? emptyValue;
                if (dateFields.includes(obj.key) && row?.[obj?.key]) {
                    const date = new Date(cellValue);
                    cellValue = new Intl.DateTimeFormat("en-GB", dateFormatOption).format(date);
                }
                acc[obj?.key] = cellValue;
                return acc;
            }, {});

            return {
                key,
                cells,
            };
        });

        result[tabName] = { columns, rows };
    });

    return result;
};



